var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"style"},[_c('img',{attrs:{"src":_vm.img}}),(_vm.selected)?_c('div',{staticClass:"select-item"},[_c('a-icon',{attrs:{"type":"check"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }